var _path, _path2, _path3, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfoList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.444 63.333h4.445v4.445h-4.445v-4.445z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 17H24v66h48.5V40M41.5 30H59M41 39h21M41 48h21M41 57h21M41 66h21",
    stroke: "#fff",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32 28h5v5h-5zM32 37h5v5h-5zM32 46h5v5h-5zM32 55h5v5h-5zM32 63h5v5h-5z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 23,
    r: 7,
    fill: "#fff"
  })));
}

export default SvgInfoList;